exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".MarketsTable[data-v-0241093e]{margin-top:2em;border-radius:5px;background:#fff;overflow:hidden;box-shadow:0 0 20px 0 rgba(0,0,0,.5)}th[data-v-0241093e]{cursor:pointer;color:rgba(0,0,0,.5);font-size:.8rem;font-weight:500}@media (max-width:650px){.mobile[data-v-0241093e]{display:none}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0241093e","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/coindetail/marketList.vue
// module id = 334
// module chunks = 0